module.exports = __webpack_public_path__ + "img/padlock.d21b587f.svg";